<template>
  <div
    :class="`formulate-input-element`"
  >
  <b-link title="Supprimer cette image" v-if="imageUrl" href="#" @click="clearUrl()">✂</b-link>
  <img v-if="imageUrl" :src="getUrlFromObject()" :width="this.context.attributes.width"/>
    
  </div>

</template>

<script>
export default {
  name:'form-image',
  props: {
    context: {
      type: Object,
      required: true
    },
  },

  data() {
    return {
      imageUrl : null
    }
  },

  mounted() {
    this.imageUrl = this.getUrlFromObject()
    console.log("this.imageUrl", this.imageUrl)
  },

  methods : {
    clearUrl() {
      this.imageUrl = ""
      if(this.context.model) this.context.model = null
    },
    getUrlFromObject() {
      //console.log("FormImage:image", this.context.model)
      if(!this.context.model) return "";
      if(!this.context.model.length) return "";
      return this.context.model[0].url
    }
  },

  computed: {
    model () {
      return this.context.model
    },
    options () {
      return this.context.options
    }
  }
}
</script>